import ClientPushCard from '@/components/client/client-push-card';
import {
	$appendClientDetailPushes,
	$clientDetailPushes,
	$setClientDetailPushes,
} from '@/entities/client.entity';
import { SOCKET_EVENTS } from '@/api/socket-events';
import { useClientVirtualFeed } from '@/hooks/use-client-virtual-feed';
import { getMockPushesForClient, paginateMockItems } from '@/mocks/fixtures';
import { useUnit } from 'effector-react';

interface ClientPushListProps {
	clientId: string;
	searchText: string;
	enabled: boolean;
	onCopy: (text: string) => void;
}

export default function ClientPushList({ clientId, searchText, enabled, onCopy }: ClientPushListProps) {
	const [pushes, setPushes, appendPushes] = useUnit([$clientDetailPushes, $setClientDetailPushes, $appendClientDetailPushes]);

	const { listRef, content } = useClientVirtualFeed({
		clientId,
		searchText,
		enabled,
		fetchEvent: SOCKET_EVENTS.getClientPushes,
		responseEvent: SOCKET_EVENTS.addClientPushes,
		items: pushes,
		setItems: setPushes,
		appendItems: appendPushes,
		getItemId: item => item.id,
		emptyLabel: 'Push-уведомлений нет',
		renderItem: push => <ClientPushCard push={push} onCopy={onCopy} />,
		devMockFetch: ({ cursor, searchText: q }) => {
			const page = paginateMockItems(
				getMockPushesForClient(clientId),
				{ cursor, searchText: q },
				(item, query) =>
					item.packageName.toLowerCase().includes(query) ||
					item.title.toLowerCase().includes(query) ||
					item.text.toLowerCase().includes(query),
			);
			return { clientId, ...page };
		},
	});

	return (
		<div ref={listRef} data-scroll-container className='h-full overflow-auto pr-1 px-1'>
			{content}
		</div>
	);
}
